webpackJsonp([1],{

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SourceList__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SourceList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SourceList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Student__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Student___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Student__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StudentList__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_StudentList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_StudentList__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'StudentList',
    component: __WEBPACK_IMPORTED_MODULE_4__components_StudentList___default.a
  }, {
    path: '/sources',
    name: 'Sourcelist',
    component: __WEBPACK_IMPORTED_MODULE_2__components_SourceList___default.a
  }, {
    path: '/:id',
    name: 'Student',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Student___default.a,
    props: true
  }]
}));

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(13);





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  actions: {
    getStudent: function getStudent(_ref, student) {
      var commit = _ref.commit,
          getters = _ref.getters;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (getters.studentById(student.id)) {
          resolve();
        } else {
          __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post('static/api.php/person', student).then(function (success) {
            commit('addStudent', success.data);
            resolve();
          }, function (error) {
            reject(error);
          });
        }
      });
    },
    listSemesters: function listSemesters(_ref2) {
      var commit = _ref2.commit;

      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get('static/api.php/semesterlist').then(function (success) {
        commit('updateSemesters', success.data);
      }, function (error) {
        console.log(error);
      });
    },
    listSources: function listSources(_ref3) {
      var commit = _ref3.commit;

      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get('static/api.php/sourcelist').then(function (success) {
        commit('updateSources', success.data);
      }, function (error) {
        console.log(error);
      });
    },
    searchStudents: function searchStudents(_ref4) {
      var commit = _ref4.commit,
          getters = _ref4.getters;

      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post('static/api.php/person_list', getters.search).then(function (success) {
        commit('updateFound', success.data);
      }, function (error) {
        console.log(error);
      });
    }
  },
  getters: {
    found: function found(state) {
      return state.found;
    },
    search: function search(state) {
      return state.search;
    },
    semesters: function semesters(state) {
      return state.semesters;
    },
    sources: function sources(state) {
      return state.sources;
    },

    studentById: function studentById(state) {
      return function (id) {
        return state.objects[id];
      };
    }
  },
  mutations: {
    addStudent: function addStudent(state, payload) {
      state.objects[payload.id] = payload;
    },
    updateFound: function updateFound(state, payload) {
      state.found = payload;
    },
    updateSemesters: function updateSemesters(state, payload) {
      state.semesters = payload.semesters;
    },
    updateSources: function updateSources(state, payload) {
      state.sources = payload.sources;
    }
  },
  state: {
    found: [],
    objects: {},
    search: { firstname: '', lastname: '', origin: '', semester: '', faculty: '' },
    semesters: [],
    sources: []
  }
}));

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(85)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(92),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(39);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['sources'])),
  created: function created() {
    if (this.sources.length === 0) {
      this.listSources();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['listSources']))
});

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['studentById'])),
  created: function created() {
    var _this = this;

    this.getStudent({ id: this.id }).then(function (success) {
      _this.student = _this.studentById(_this.id);
    }, function (error) {
      return console.log(error);
    });
  },
  data: function data() {
    return {
      student: {}
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['getStudent'])),
  props: {
    id: { required: true }
  }
});

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(13);





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['found', 'search', 'semesters'])),
  created: function created() {
    if (this.semesters.length === 0) {
      this.listSemesters();
    }
    if (this.found.length === 0) {
      this.searchStudents();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['listSemesters', 'searchStudents']))
});

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(84)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(91),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(83)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(90),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(86)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(93),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 90:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.student.firstname) + " " + _vm._s(_vm.student.lastname))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.student.lastname))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Vorname")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.student.firstname))])]), _vm._v(" "), (_vm.student.origin) ? _c('tr', [_c('th', [_vm._v("Herkunftsort")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.student.origin))])]) : _vm._e(), _vm._v(" "), (_vm.student.notes) ? _c('tr', [_c('th', [_vm._v("Bemerkungen")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.student.notes))])]) : _vm._e()]), _vm._v(" "), (_vm.student.hasRegistrations) ? _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.student.registrations), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.semester_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.faculty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.date))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.student.hasRecords) ? _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._l((_vm.student.records), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.source))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.details))])])
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('tr', {
    staticClass: "noprint"
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "sources"
    }
  }, [_vm._v("Bio-bibliographische Nachweise")])], 1)])])])], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('h1', [_vm._v("Immatrikulationen")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Semester")]), _vm._v(" "), _c('th', [_vm._v("Fakultät/Fach")]), _vm._v(" "), _c('th', [_vm._v("Datum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h1', [_vm._v("Belege")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Quelle")]), _vm._v(" "), _c('th', [_vm._v("Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "noprint"
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('hr', {
    attrs: {
      "size": "1"
    }
  })])])
}]}

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Bio-bibliographische Nachweise")]), _vm._v(" "), _c('dl', [_vm._l((_vm.sources), function(item) {
    return [_c('dt', [_vm._v(_vm._s(item.code))]), _vm._v(" "), (item.author) ? _c('dd', [_vm._v(_vm._s(item.author))]) : _vm._e(), _vm._v(" "), (item.publisher) ? _c('dd', [_vm._v(_vm._s(item.publisher) + " (Hrsg.)")]) : _vm._e(), _vm._v(" "), _c('dd', [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.pages) ? _c('dd', [_vm._v("S. " + _vm._s(item.pages))]) : _vm._e(), _vm._v(" "), (item.publication) ? _c('dd', [_vm._v(_vm._s(item.publication))]) : _vm._e(), _vm._v(" "), (item.notes) ? _c('dd', [_c('i', [_vm._v(_vm._s(item.notes))])]) : _vm._e()]
  })], 2), _vm._v(" "), _c('table', {
    staticClass: "noprint",
    attrs: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tr', [_c('td', [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Datenbank durchsuchen")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('hr', {
    attrs: {
      "size": "1"
    }
  })])])
}]}

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', [_vm._m(0), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Name:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.lastname),
      expression: "search.lastname"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.search.lastname)
    },
    on: {
      "keyup": function($event) {
        _vm.searchStudents()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search.lastname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("Vorname:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.firstname),
      expression: "search.firstname"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Vorname"
    },
    domProps: {
      "value": (_vm.search.firstname)
    },
    on: {
      "keyup": function($event) {
        _vm.searchStudents()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search.firstname = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Herkunftsort:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.origin),
      expression: "search.origin"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Herkunftsort"
    },
    domProps: {
      "value": (_vm.search.origin)
    },
    on: {
      "keyup": function($event) {
        _vm.searchStudents()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search.origin = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Semester:")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.semester),
      expression: "search.semester"
    }],
    attrs: {
      "name": "semester"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.search.semester = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.searchStudents()
      }]
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.semesters), function(item) {
    return _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('td', [_vm._v("Fakultät/Fach:")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.faculty),
      expression: "search.faculty"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Fakultät/Fach"
    },
    domProps: {
      "value": (_vm.search.faculty)
    },
    on: {
      "keyup": function($event) {
        _vm.searchStudents()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search.faculty = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h1', [_vm._v("Gefunden: " + _vm._s(_vm.found.size || 0))])])]), _vm._v(" "), _vm._l((_vm.found.persons), function(item) {
    return _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": item.id
      }
    }, [_vm._v(_vm._s(item.lastname) + " " + _vm._s(item.firstname))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.origin))])])
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tr', {
    staticClass: "noprint"
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/sources"
    }
  }, [_vm._v("Bio-bibliographische Nachweise")])], 1)])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('h1', [_vm._v("Datenbank durchsuchen:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "noprint"
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('hr', {
    attrs: {
      "size": "1"
    }
  })])])
}]}

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[41]);


// WEBPACK FOOTER //
// static/js/app.9ed99e71a64af0c28ab8.js